import PropTypes from 'prop-types'

import Label from '@s-ui/react-atom-label'
import {useSuiContext} from '@s-ui/react-context'

import {BASE_CLASS, COMPONENTS_BY_DESIGN, DESIGNS} from './config.js'

const FormLocation = ({
  aggregations,
  design,
  initialSearch,
  isLoading,
  onChange,
  overlayContentRef,
  withLabel = true
}) => {
  const {i18n} = useSuiContext()

  const Component = COMPONENTS_BY_DESIGN[design]

  return (
    <div className={BASE_CLASS}>
      {withLabel && (
        <div className={`${BASE_CLASS}-label`}>
          <Label text={i18n.t('COMMON.LOCATION')} />
        </div>
      )}
      <Component
        aggregations={aggregations}
        design={design}
        isLoading={isLoading}
        onChange={onChange}
        overlayContentRef={overlayContentRef}
        search={initialSearch}
      />
    </div>
  )
}

const FormLocationBasicContent = props => <FormLocation {...props} design={DESIGNS.BASIC} />

FormLocationBasicContent.displayName = 'FormLocationBasicContent'

const FormLocationRightSelectPopover = props => <FormLocation {...props} design={DESIGNS.RIGHT_POPOVER} />

FormLocationRightSelectPopover.displayName = 'FormLocationRightSelectPopover'

const FormLocationModalSelectPopover = props => <FormLocation {...props} design={DESIGNS.MODAL_POPOVER} />

FormLocationModalSelectPopover.displayName = 'FormLocationModalSelectPopover'

FormLocation.displayName = 'FormLocation'
FormLocation.propTypes = {
  aggregations: PropTypes.array,
  design: PropTypes.string,
  initialSearch: PropTypes.object,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  withLabel: PropTypes.bool
}

export {FormLocationBasicContent, FormLocationRightSelectPopover, FormLocationModalSelectPopover}

export default FormLocation
